import { ReactElement } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { RequesteeSearch } from './RequesteeSearch/RequesteeSearch';
import { Agreements } from './Agreements/Agreements';

/**
 * Wrapping component serving as a nested router and shared for Request Flow components.
 *
 * @returns {ReactElement} rendered component.
 */
const RequestFlow = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<Route
				path={`${path}/RequesteeSearch`}
				render={routeProps => <RequesteeSearch {...routeProps} />}
			/>
			<Route
				path={`${path}/Agreements`}
				render={() => <Agreements />}
			/>
		</Switch>
	);
};

export { RequestFlow };
